const OEEBase = "";
const VorneBase = "https://www.vorne.com";
const LeanProductionBase = "https://www.leanproduction.com";
const LeanProductionWebsiteRoute = LeanProductionBase;
const VorneWebsiteRoute = "https://www.vorne.com";

const Routes = {
  OEE: {
    PracticalOEE: `${OEEBase}/practical-oee/`,
    CalculatingOEE: `${OEEBase}/calculating-oee/`,
    SixBigLosses: `${OEEBase}/oee-six-big-losses/`,
    ImproveOEE: `${OEEBase}/improve-oee/`,
    Factors: `${OEEBase}/oee-factors/`,
    ImplementingOEE: `${OEEBase}/implementing-oee/`,
    WorldClassOEE: `${OEEBase}/world-class-oee/`,
    TEEP: `${OEEBase}/teep/`,
    HiddenFactory: `${OEEBase}/hidden-factory/`,
    AddressSixBigLosses: `${OEEBase}/address-six-big-losses/`,
    FreeTools: `${OEEBase}/free-oee-tools/`,
    VisualOEE: `${OEEBase}/visual-oee/`,
    Topics: `${OEEBase}/oee-topics-overview/`,
    WorldClass: `${OEEBase}/world-class-oee/`,
    Privacy: `${OEEBase}/privacy/`,
    WhatIsOEE: "/",
    FAQ: `${OEEBase}/faq/`,
    Glossary: `${OEEBase}/oee-glossary/`,
    TaktTime: `${OEEBase}/takt-time/what-is-takt-time/`,
    CalculatingTaktTime: `${OEEBase}/takt-time/how-to-calculate/`,
    ManufacturingTaktTime: `${OEEBase}/takt-time/manufacturing/`,
    TaktTimeOrigins: `${OEEBase}/takt-time/origins/`,
    TaktTimeCycleTime: `${OEEBase}/takt-time/cycle-time/`,
    TaktTimeCluster: `${OEEBase}/takt-time/`,
    About: `${OEEBase}/about/`,
    ReusingContent: `${OEEBase}/reusing-content/`,
    CookiePolicy: `${OEEBase}/cookie/`,
    OEEForm: `${OEEBase}/oee-quick-start.pdf`,
    OEEWorksheet: `${OEEBase}/oee-worksheet/`,
    IdaInformationPDF: `${OEEBase}/ida-audit-oee-information-worksheet.pdf`,
    IdaDecisionPDF: `${OEEBase}/ida-audit-oee-decision-worksheet.pdf`,
    IdaActionPDF: `${OEEBase}/ida-audit-oee-action-worksheet.pdf`,
    StopReasonSheet: `${OEEBase}/oee-stop-reason-tick-sheet.pdf`,
    StopEventLog: `${OEEBase}/oee-stop-event-log.pdf`,
    Contact: {
      InfoEmail: "mailto:info@oee.com",
      AskAnExpertEmail: "mailto:askanexpert@oee.com",
      Phone: "tel:+1-630-875-3600",
      LinkedIn: "https://www.linkedin.com/company/vorne-industries/",
    },
  },
  Vorne: {
    TPS: `${VorneBase}/learn/key-concepts/toyota-production-system/`,
    ImproveTheConstraint: `${VorneBase}/improve-the-constraint.pdf`,
    OEESpreadsheet: `${VorneBase}/support/data-sheets/`,
    StopEventLog: `${VorneBase}/learn/tools/overall-equipment-effectiveness/oee-stop-event-log.pdf`,
    StopReasonSheet: `${VorneBase}/learn/tools/overall-equipment-effectiveness/oee-stop-reason-tick-sheet.pdf`,
    TopLossReport: `${VorneBase}/learn/key-concepts/oee/oee-manual-top-loss-report.xlsx`,
    ImproveConstraint: `${VorneBase}/learn/tools/improve-the-constraint/`,
    Agile: `${VorneBase}/learn/accelerants/agile/`,
    XlProductivityAppliance: `${VorneBase}/products/xl/`,
    XlHd: `${VorneBase}/products/xl/models/xl-hd-productivity-appliance/`,
    FreeTrial: `${VorneBase}/products/free-trial/`,
    NewFeatures: `${VorneBase}/products/xl-software-versions/`,
    TechSupport: `${VorneBase}/support/technical/`,
    ScheduleWebinar: `${VorneBase}/support/technical-support/book-meeting/`,
    TopLosses: `${VorneBase}/learn/silver-bullets/top-losses/`,
    SMED: `${VorneBase}/learn/tools/single-minute-exchange-of-die/`,
    SIC: `${VorneBase}/learn/silver-bullets/short-interval-control/`,
    SixBigLosses: `${VorneBase}/learn/tools/six-big-losses/`,
    WinTheShift: `${VorneBase}/solutions/use-cases/win-the-shift/`,
    OEE: `${VorneBase}/learn/tools/overall-equipment-effectiveness/`,
    Integration: `${VorneBase}/products/integration-tools/`,
    OEESoftware: `${VorneBase}/solutions/applications/oee-software/`,
  },
  LeanProduction: {
    TheoryOfConstraints: `${LeanProductionBase}/theory-of-constraints/`,
    LeanOEE: `${LeanProductionBase}/oee/`,
    WinTheShift: `${LeanProductionBase}/win-the-shift/`,
    LeanImproveConstraint: `${LeanProductionBase}/theory-of-constraints/`,
  },
  CopyscapeSite: "https://www.copyscape.com/plagiarism.php",
  TaktTranslation: "https://en.langenscheidt.com/german-english/takt",
  TaktzeitTranslation: "https://en.langenscheidt.com/german-english/taktzeit",
  ZeitTranslation: "https://en.langenscheidt.com/english-german/time",
  LeanProductionWebsiteRoute,
  VorneWebsiteRoute,
};

export default Routes;
